import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { MobileNavigation } from "./MobileNavigation";
import { DesktopNavigation } from "./navigation/DesktopNavigation";
import { useAuthStatus } from "@/hooks/useAuthStatus";
import { useSubscriptionStatus } from "@/hooks/useSubscriptionStatus";

const Navigation = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [unreadCount, setUnreadCount] = useState(0);
  const { userRole, isOpenToJobs, isHiring, setIsOpenToJobs, setIsHiring } = useAuthStatus();
  const { data: subscription } = useSubscriptionStatus();

  // Query to fetch unread notifications count
  const { data: notifications } = useQuery({
    queryKey: ["unreadNotifications"],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user?.id) return [];

      const { data, error } = await supabase
        .from("notifications")
        .select("*")
        .eq("user_id", session.user.id)
        .eq("read", false);

      if (error) {
        console.error("Error fetching notifications:", error);
        return [];
      }

      return data;
    },
    refetchInterval: 30000, // Refetch every 30 seconds
  });

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Search query:", searchQuery);
  };

  // Update unread count when notifications change
  useEffect(() => {
    if (notifications) {
      setUnreadCount(notifications.length);
    }
  }, [notifications]);

  return (
    <>
      <DesktopNavigation
        userRole={userRole}
        isOpenToJobs={isOpenToJobs}
        isHiring={isHiring}
        setIsOpenToJobs={setIsOpenToJobs}
        setIsHiring={setIsHiring}
        subscription={subscription}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleSearch={handleSearch}
        unreadCount={unreadCount}
      />
      <div className="md:hidden">
        <MobileNavigation />
      </div>
    </>
  );
};

export default Navigation;